import {
  FETCH_AVERAGE_RATING_DATA,
  FETCH_USER_RATING_DATA,
  FETCH_USER_UNRATED_DATA,
  USER_FEEDBACK,
  USER_GIVEN_RATING,
  FETCH_ALL_QUESTIONS
} from '../../constants/ratingsConstants';

const initialstate = {
  avgRating: '',
  userRating: '',
  unRatedProducts: []
};

export default function ratingsReducers(state = initialstate, action) {
  const { type = '', data = {} } = action || {};
  switch (type) {
    case FETCH_USER_UNRATED_DATA:
      return {
        ...state,
        unRatedProducts: data
      };
    case USER_GIVEN_RATING:
      return {
        ...state,
        userGivenRating: data
      };
    case USER_FEEDBACK:
      return {
        ...state,
        feedbackData: data
      };
    case FETCH_ALL_QUESTIONS:
      return {
        ...state,
        questions: data
      };
    default:
      return state;
  }
}
